const setBotPitAISetting = (data) => ({
    type: 'BOT_PITAI_SETTING',
    data: data
  })
  
  export { setBotPitAISetting }
  